import { FC } from "react";
import { Layers } from "lucide-react";

interface ServiceHeaderProps {
    serviceInfo: { name: string; status: string } | null;
}

const ServiceHeader: FC<ServiceHeaderProps> = ({ serviceInfo }) => {
    if (!serviceInfo) return null;

    return (
        <div className="mb-6 md:mb-8">
            <div className="relative overflow-hidden rounded-xl md:rounded-2xl bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 border border-blue-200 shadow-lg">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-blue-200/30 to-indigo-200/30 rounded-full blur-xl"></div>
                    <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 w-20 h-20 md:w-32 md:h-32 bg-gradient-to-br from-indigo-200/20 to-purple-200/20 rounded-full blur-xl"></div>
                </div>

                <div className="relative p-4 md:p-6">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div className="flex items-center space-x-3 md:space-x-4">
                            <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
                                <Layers className="w-5 h-5 md:w-6 md:h-6 text-white"/>
                            </div>
                            <div>
                                <h1 className="text-lg md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                                    {serviceInfo.name}
                                </h1>
                                <p className="text-gray-600 text-xs md:text-sm">Microservice Architecture</p>
                            </div>
                        </div>

                        <div className="flex items-center space-x-2 px-3 md:px-4 py-2 rounded-full bg-white/70 backdrop-blur-sm border border-blue-200 self-start sm:self-center">
                            <div className={`w-2 h-2 rounded-full ${
                                serviceInfo.status === 'IDLE' ? 'bg-green-500' :
                                    serviceInfo.status === 'GENERATING_SHREDS' ? 'bg-yellow-500 animate-pulse' :
                                        'bg-red-500'
                            }`}/>
                            <span className="text-xs md:text-sm font-medium text-gray-700 capitalize">
                                {serviceInfo.status.toLowerCase().replace('_', ' ')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceHeader;